import PropTypes from "prop-types";
import {
  createMarkup,
  componentCheckSize,
} from "../../../utils/helperServices";
import styles from "./PaymentMethodTile.module.scss";
import config from "../../../config/index";

const PaymentMethodTile = ({
  variant,
  data,
  handleOnDelete,
  handleOnClick,
  selectedItem,
  deleteOption,
  id,
  className,
  showDesc,
  defaultIcon,
  defaultIconUrl,
}) => {
  const isMobile = componentCheckSize() <= 576;
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const wrapperClassName =
    variant == "card" ? styles["card"] : styles["option"];

  return (
    <>
      {data && (
        <>
          <div
            className={`${styles["paymentMethodTile"]} ${wrapperClassName} ${
              selectedItem == data.id ? styles["greenBorder"] : ""
            } ${className}`}
            id={`${id} ${selectedItem == data.id ? id + "-green-tick" : ""}`}
            onClick={() => {
              handleOnClick(data);
            }}
          >
            <div className={styles["top"]}>
              {(data.icon || defaultIcon) && (
                <div className={styles["icon"]}>
                  <img src={defaultIcon ? defaultIconUrl : data.icon} />
                </div>
              )}
              {data.name && (
                <div className={styles["content"]}>
                  <div className={styles["heading"]}>{data.name}</div>
                  {data.details && variant == "card" && !isMobile && (
                    <div className={styles["details"]}>
                      <span className={styles["number"]}>
                        {data.details.number}
                      </span>
                      {data.details.expire && (
                        <span className={styles["expire"]}>
                          Expires {data.details.expire}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              )}

              {data && variant == "card" && deleteOption && (
                <>
                  <div className={styles["action-btn"]}>
                    <div
                      className={`${styles["btn"]} ${styles["delete"]}`}
                      id={`${id}-delete`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOnDelete(data);
                      }}
                    >
                      <i
                        className={`${styles["icon"]} ${styles["icon__delete"]}`}
                      />
                      <span className={styles["label"]}>Remove</span>
                    </div>
                  </div>
                </>
              )}

              <div
                className={`${
                  selectedItem == data.id ? styles["triangle"] : ["d-none"]
                }`}
              >
                <div className={styles["click"]}>
                  <img
                    className={styles["click-tick"]}
                    src={`${imagePrefix}/assets/images/tick.svg`}
                    alt="tick"
                  />
                </div>
              </div>
            </div>
            {data.details && variant == "card" && isMobile && (
              <div className={styles["bottom"]}>
                <div className={styles["content"]}>
                  <div className={styles["details"]}>
                    <span className={styles["number"]}>
                      {data.details.number}
                    </span>
                    {data.details.expire && (
                      <span className={styles["expire"]}>
                        Expires {data.details.expire}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          {data?.description && selectedItem == data.id && showDesc && (
            <div
              className={styles["desc"]}
              dangerouslySetInnerHTML={createMarkup(data.description)}
            ></div>
          )}
        </>
      )}
    </>
  );
};

PaymentMethodTile.propTypes = {
  variant: PropTypes.oneOf(["option", "card"]),
  data: PropTypes.object,
  handleOnDelete: PropTypes.func,
  handleOnClick: PropTypes.func,
  deleteOption: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  showDesc: PropTypes.bool,
  defaultIcon: PropTypes.bool,
  defaultIconUrl: PropTypes.string,
};

PaymentMethodTile.defaultProps = {
  variant: "option",
  data: {},
  deleteOption: true,
  showDesc: true,
  defaultIcon: false,
};

export default PaymentMethodTile;
